import { render, staticRenderFns } from "./MailTexts.vue?vue&type=template&id=891c4fd6"
import script from "./MailTexts.vue?vue&type=script&lang=js"
export * from "./MailTexts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports